export default {"src":"/_next/static/media/chevronRight_24.b1b277b3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};